<p-dialog
    class="dialog"
    [header]="title"
    [modal]="true"
    [(visible)]="visible"
    [style]="{ width: vwWidth }"
    [breakpoints]="{ '768px': '95vw' }"
    (onShow)="onShow.emit()"
    (onHide)="onHide.emit()"
    [closable]="closable"
    [baseZIndex]="5000"
>
    <ng-content></ng-content>
    @if (buttons.length > 0) {
        <ng-template pTemplate="footer">
            <div class="button-footer">
                @for (btype of buttons; track btype) {
                    @switch (btype) {
                        @case ('ok') {
                            <button
                                class="button-primary disabled:bg-slate-200 disabled:text-slate-500 disabled:opacity-100"
                                type="button"
                                [disabled]="disabled"
                                (click)="okClicked.emit()"
                                (keypress)="okClicked.emit()"
                                i18n="@@button.ok"
                                >OK</button
                            >
                        }
                        @case ('save') {
                            <button
                                type="button"
                                class="button-primary"
                                (click)="saveClicked.emit()"
                                (keypress)="saveClicked.emit()"
                                i18n="@@button.save"
                                >Bewaar</button
                            >
                        }
                        @case ('cancel') {
                            <button
                                class="button-light"
                                type="button"
                                (click)="cancelClicked.emit()"
                                (keypress)="cancelClicked.emit()"
                                i18n="@@button.cancel"
                                >Annuleer</button
                            >
                        }
                        @case ('close') {
                            <button class="button-primary" type="button" (click)="hide()" (keypress)="hide()" i18n="@@button.close"
                                >Sluit</button
                            >
                        }
                    }
                }
            </div>
        </ng-template>
    }
</p-dialog>
